<template>
<div class="about">
    <v-header />
    <v-sidebar />
    <div class="content-box-entity">
        <div class="content">
            <div>
                <div class="container">
                    <div class="handle-box">
                        <el-select v-model="query.email" style="width: 180px;" allow-create clearable filterable placeholder="邮箱">
                            <el-option v-for="item in emaillist" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select> 
                         <el-select v-model="query.send" style="width: 180px;" allow-create clearable filterable placeholder="发送人">
                            <el-option v-for="item in sendlist" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                         <el-select v-model="query.name" style="width: 180px;" allow-create clearable filterable placeholder="邮件标题">
                            <el-option v-for="item in namelist" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>                     
                        <el-button type="primary" icon="el-icon-search" style="margin: 5px; width: 120px;" @click="handleSearch">搜索</el-button>
                    </div>
                    
                    <el-table :data="tableData" border fit style="width: 100%;" class="table" ref="table" header-cell-class-name="table-header" size="mini" v-loading="listLoading" row-class-name="success-row" stripe
                    :cell-style="changColor" @selection-change="handleRowSelect" @row-click="handleClick">
                
                        <el-table-column type="index" width="50" label="序号" align="center"  />
                        <el-table-column prop="name" label="邮件标题"  width="190" align="center" ></el-table-column>
                        <el-table-column prop="email" label="收件箱" width="200" align="center" ></el-table-column>
                        <el-table-column prop="sendAt" label="邮件发送时间"  width="200" align="center" ></el-table-column>
                        <el-table-column prop="send" label="发送人" width="180" align="center" ></el-table-column>
                    </el-table>
                   
                    <div class="pagination">
                        <el-pagination background @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="query.pageNo" :page-sizes="[10,20,50,100,500]" :page-size="query.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import vHeader from "./Header.vue";
import vSidebar from "./Sidebar.vue";

import {
   
    sendrecord_list_page, 
    sendrecord_list_getNames,
    sendrecord_list_getEmails,
    sendrecord_list_getSends 
        
} from '../../api';
import {
    dealResult
} from "../../api/common";

export default {
    name: "AdminSendRecord",
    components: {
        vHeader,
        vSidebar
    },
    data() {
        return {
            delMsgli: ["广告", "心术不正", "言辞不雅"],
            delVisible: false,
            delData: {},
            files: null,
            decimalPart: '', // 小数点后的字符
            msg: null,
            moveVisible: false,
            listLoading: false,
            FILE_ACTION: '',
            filteredOptions: [], // 用于存储过滤后的选项
            lander: {},
            trashNum: 0,
            typelist: [],
            countrylist: [],
            
            region2list: [],
            religionlist: [],
            languagelist: [],
            statuslist: [
                {
                    value: '是',
                    label: '是'
                },
                {
                    value: '否',
                    label: '否'
                }
            ],
            namelist: [],
            emaillist: [],
            sendlist: [],
            tableData: [],
            contypelist: [{
                    value: '线上',
                    label: '线上'
                },
                {
                    value: '线下',
                    label: '线下'
                }
            ],
            deleteSeleteData: {},
            query: {
                pageNo: 1,
                pageSize: 10,
            },
            pageTotal: 0,
            topbestVisible: false,
            dialogFormVisible: false,
            topbestData: {
                id: '',
                start: '',
                end: '',
            },
           
        };
    },
    methods: {

        addRefresh() {
            this.reload()
        },

        // 刷新数据
        reload() {
            this.handleSearch()
        },

        changColor({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 23 && row.status  === '是') {
        return { color: 'green' }
      }
      if (columnIndex === 23 && row.status === '否') {
        return { color: 'red' }
      }      
    },
        handleClick(row) {
            this.$refs.table.toggleRowSelection(row)
        },
       
        // 查询操作
        handleSearch() {

            this.query.pageNo = 1;
            this.getPage();
        },

        // 分页导航
        handlePageChange(val) {
            this.query.pageNo = val;
            this.getPage();
        },
        handleSizeChange(val) {
            this.query.pageNo = 1;
            this.query.pageSize = val;
            this.getPage();
        },

       

       
        handleRowSelect(selectionChange) {
            this.deleteSeleteData = selectionChange
        },
        



        //获取列表数据
        getPage() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            this.listLoading = true
            sendrecord_list_page(this.query).then((res) => {

                dealResult(res.data);
                if (res.data.status == 1) {
                    this.tableData = res.data.obj.list
                    this.pageTotal = res.data.obj.total //该页总共多少条记录
                } else {
                    this.$message.error(res.data.msg)
                }
                this.listLoading = false
            })
        },
        //去重获取列表数据
        getItems() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            sendrecord_list_getNames(this.query).then((res) => {
                this.namelist = res.data.obj
            }) 
             sendrecord_list_getEmails(this.query).then((res) => {
                this.emaillist = res.data.obj
            }) 
             sendrecord_list_getSends(this.query).then((res) => {
                this.sendlist = res.data.obj
            })          
        },
    

    },
    mounted() {
        this.lander = JSON.parse(this.$store.state.logininfo);
        //去后端查询所有的用户给tableData赋值
        this.getPage();       
        this.getItems();
        this.lander = JSON.parse(this.$store.state.logininfo);
        this.faceimg = this.lander.faceimg;
        this.FILE_ACTION = process.env.VUE_APP_API_ROOT + '/entity/entitylist/importExcel?uid=' + this.lander.uid + "&token=" + this.lander.token;
        if (this.lander.role == '100') {
        }
        if (this.lander.role == '50') {
        }
    }
}
</script>

<style scoped>
.handle-box {
    margin-bottom: 5px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
    width: 150px;
}

.content-box-entity {
    position: absolute;
    left: 200px;
    right: 0;
    top: 0px;
    bottom: 0;
    padding-bottom: 30px;
    -webkit-transition: left .3s ease-in-out;
    transition: left .3s ease-in-out;
    background: #f0f0f0;
}

.filter-container-right {
    float: right;
}

.pagination {
    display: inline-block;
    padding-left: 200px;
    margin: 20px 0;
    border-radius: 4px;
}

.drawer-item {
    color: rgba(0, 0, 0, .65);
    font-size: 16px;
    padding: 12px 0;
}

.drawer-title {
    margin-bottom: 1px;
    margin-top: 15px;
    color: rgba(0, 0, 0, .85);
    font-size: 22px;
    line-height: 22px;
}

/*滚动条的宽度*/
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px;
    height: 10px;
}

/*滚动条滑块*/
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #409eff;
    border-radius: 3px;
}
</style>
